import { render } from "./graph.vue?vue&type=template&id=4a492cf5"
const script = {}
script.render = render

export default script